<ng-container *transloco="let t">
  <mat-card class="mat-elevation-z4 h-100">
    <mat-card-title>
      <mat-toolbar class="p-0 no-bg border-bottom-1eee">
        <h2>{{t('activeUsers.title')}}</h2>
        <span class="fill-remaining-space"></span>
        <a title="{{t('buttons.refresh')}}" (click)="refresh()">
          <mat-icon><i class="material-icons">refresh</i></mat-icon>
        </a>
      </mat-toolbar>
    </mat-card-title>
    <mat-card-content>
      <gt-enhanced-table #table [sourceFn]="sourceFn" [columns]="columns" [hidePageSize]="true">
      </gt-enhanced-table>
    </mat-card-content>
  </mat-card>
</ng-container>
